import { environment } from '../environments/environment'

export async function loadRuntimeConfig(): Promise<void> {
  if (!environment.production) {
    return
  }

  const response = await fetch('assets/config.json')
  const config = await response.json()

  // Merge runtime config into the environment object so all existing
  // consumers (imports, injection tokens) continue to work unchanged.
  // The keycloak issuer needs the /flowx suffix stripped, matching the
  // original environment.prod.ts behavior.
  if (config.keycloak?.issuer) {
    config.keycloak.issuer = config.keycloak.issuer.replace(/\/flowx$/, '')
  }

  Object.assign(environment.keycloak, config.keycloak)
  Object.assign(environment.analyticsConfig, config.analyticsConfig)
  Object.assign(environment.e2eCredentials, config.e2eCredentials)
  delete config.keycloak
  delete config.analyticsConfig
  delete config.e2eCredentials
  Object.assign(environment, config)
}
